import React from "react";

export const Card: React.FC<React.HTMLProps<HTMLDivElement>> = ({ children, className, ...props }) => (
    <div className={`bg-gray-800 rounded-lg shadow-md ${className}`} {...props}>
        {children}
    </div>
);

export default Card;